import QdContainer from "components/Common/QdContainer"
import React, { useContext, useState } from "react"
import { Button, Card, CardBody, Form, Input } from "reactstrap"
import Header from "./Header"
import TenantConnectionForm from "./TenantConnectionForm"
import TenantConnectionContext, { Provider } from "./TenantConnectionContext"
import TenantConnectionDetails from "./TenantConnectionDetails"
import TenantIntegrationForm from "./TenantIntegrationForm"

function Inner() {
  const { isAdmin, scac, setScac } = useContext(TenantConnectionContext)
  const [scacInput, setScacInput] = useState("")
  const [showForm, setShowForm] = useState(false)
  const [showIntegrationForm, setShowIntegrationForm] = useState(false)

  const handleSearch = e => {
    e.preventDefault()
    setShowForm(false)
    setShowIntegrationForm(false)
    setScac(scacInput.trim())
  }

  return (
    <QdContainer>
      <Header />
      {isAdmin && (
        <Card className="p-3 my-3">
          <CardBody className="p-0">
            <Form className="d-flex gap-2" onSubmit={handleSearch}>
              <Input
                type="text"
                placeholder="Enter SCAC"
                value={scacInput}
                onChange={e => setScacInput(e.target.value)}
                style={{ maxWidth: "240px" }}
              />
              <Button color="primary" type="submit">
                Search
              </Button>
            </Form>
          </CardBody>
        </Card>
      )}
      {(!isAdmin || scac) && (
        <>
          {showForm && (
            <TenantConnectionForm hideForm={() => setShowForm(false)} />
          )}
          {showIntegrationForm && (
            <TenantIntegrationForm
              hideForm={() => setShowIntegrationForm(false)}
            />
          )}
          {!showForm && !showIntegrationForm && (
            <TenantConnectionDetails
              handleEdit={() => setShowForm(true)}
              handleEditIntegration={() => setShowIntegrationForm(true)}
            />
          )}
        </>
      )}
    </QdContainer>
  )
}

function TenantConnections() {
  return (
    <Provider>
      <Inner />
    </Provider>
  )
}

export default TenantConnections
